import React, { useState, useEffect, useCallback } from 'react';
import { IoSearchOutline } from 'react-icons/io5';
import '../../../styles/searchbar/SearchBar.css';

const SearchBar = ({
                       value = '',
                       onChange,
                       onSearch,
                       placeholder = 'Szukaj...',
                       mobileBreakpoint = 1024,
                       autoFocus = false,
                       className = '',
                       disabled = false,
                       ariaLabel = 'Pole wyszukiwania',
                       width,
                   }) => {
    const [isMobile, setIsMobile] = useState(
        typeof window !== 'undefined' ? window.innerWidth <= mobileBreakpoint : false
    );

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= mobileBreakpoint);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [mobileBreakpoint]);

    const getPlaceholder = useCallback(() => {
        if (typeof placeholder === 'string') {
            return placeholder;
        }
        if (typeof placeholder === 'object' && placeholder !== null) {
            return isMobile
                ? (placeholder.mobile || placeholder.desktop || 'Szukaj...')
                : (placeholder.desktop || placeholder.mobile || 'Szukaj...');
        }
        return 'Szukaj...';
    }, [placeholder, isMobile]);

    const handleChange = (e) => {
        const newValue = e.target.value;

        if (onChange) {
            onChange(newValue);
        }

        if (onSearch) {
            onSearch(newValue);
        }
    };

    const handleClear = () => {
        if (onChange) {
            onChange('');
        }

        if (onSearch) {
            onSearch('');
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Escape' && value) {
            handleClear();
        }
    };

    const getWidthStyle = () => {
        if (!width || isMobile) return {};

        if (typeof width === 'number') {
            return { width: `${width}px` };
        }

        return { width };
    };

    return (
        <div
            className={`searchbar-wrapper ${className}`.trim()}
            style={getWidthStyle()}
        >
            <IoSearchOutline className="searchbar-icon" />
            <input
                type="text"
                className="searchbar-input"
                placeholder={getPlaceholder()}
                value={value}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                autoFocus={autoFocus}
                disabled={disabled}
                aria-label={ariaLabel}
            />
            {value && !disabled && (
                <button
                    type="button"
                    className="searchbar-clear-btn"
                    onClick={handleClear}
                    aria-label="Wyczyść wyszukiwanie"
                >
                    ×
                </button>
            )}
        </div>
    );
};

export default SearchBar;